import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from './../local-storage/local-storage.service';

@Injectable()
export class AuthGuardService {

  constructor(private localStorageService: LocalStorageService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const login = this.localStorageService.get('login');
    if (login) {
      return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }

}
